import React, {Component} from 'react'
import {Button, ButtonGroup, ButtonToolbar} from 'react-bootstrap'
import './BackOfficeFiltersComponent.css'

export default class BackOfficeFiltersComponent extends Component {
    render(){
        return(
                <ButtonToolbar>
                    <Button onClick={this.props.onAllClick} className="ciaobtn">Tutti</Button>
                    <Button className="ciaobtn" onClick={this.props.onWaitingClick}>In attesa di approvazione</Button>
                </ButtonToolbar>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/BackOfficeFiltersComponent.js